var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-search-product-autocomplete flex-grow-1"
  }, [_c('v-text-field', {
    ref: "field",
    staticClass: "table-search-product-autocomplete__field",
    "class": {
      'table-search-product-autocomplete__field--filled': _vm.isQueryFilled
    },
    attrs: {
      "value": _vm.query,
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "single-line": "",
      "clearable": "",
      "prepend-inner-icon": "mdi-magnify",
      "placeholder": _vm.placeholder,
      "aria-label": _vm.placeholder,
      "autofocus": _vm.autofocus,
      "loading": _vm.loading
    },
    on: {
      "input": _vm.onQueryInput,
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "click:clear": _vm.onClear,
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) return null;
        $event.preventDefault();
        return _vm.focusNext.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) return null;
        $event.preventDefault();
        return _vm.focusPrevious.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.selectHighlighted.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        $event.preventDefault();
        return _vm.closeMenu.apply(null, arguments);
      }]
    }
  }), _vm.menuOpen && (_vm.loading || _vm.suggestions.length || _vm.query.length >= _vm.minChars) ? _c('v-card', {
    staticClass: "table-search-product-autocomplete__menu",
    attrs: {
      "elevation": "4"
    },
    on: {
      "mousedown": function mousedown($event) {
        $event.preventDefault();
      }
    }
  }, [_c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": ""
    }
  }, [_vm.loading ? _c('v-list-item', {
    attrs: {
      "disabled": ""
    }
  }, [_c('v-list-item-title', {
    staticClass: "text-caption grey--text"
  }, [_vm._v(" " + _vm._s(_vm.$translate("loading")) + " ")])], 1) : _vm.query.length >= _vm.minChars && !_vm.suggestions.length ? _c('v-list-item', {
    attrs: {
      "disabled": ""
    }
  }, [_c('v-list-item-title', {
    staticClass: "text-caption grey--text"
  }, [_vm._v(" " + _vm._s(_vm.$translate("noResults")) + " ")])], 1) : _vm._e(), _vm._l(_vm.suggestions, function (product, index) {
    return _c('v-list-item', {
      key: product.id,
      "class": {
        'table-search-product-autocomplete__item--active': index === _vm.highlightedIndex
      },
      on: {
        "mousedown": function mousedown($event) {
          $event.preventDefault();
          return _vm.selectProduct(product);
        },
        "mouseenter": function mouseenter($event) {
          _vm.highlightedIndex = index;
        }
      }
    }, [_c('v-list-item-content', {
      staticClass: "py-2"
    }, [_c('ProductName', {
      staticClass: "text-body-2",
      attrs: {
        "product": product,
        "display-code": true,
        "inline-code": true
      }
    })], 1)], 1);
  })], 2)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }